import { cn } from '@/lib/utils';
import {
  Landmark,
  LayoutDashboard,
  MessageCircle,
  MoreHorizontal,
  Wallet,
} from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const primaryTabs = [
  { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { name: 'Accounts', href: '/accounts', icon: Landmark },
  { name: 'Assistant', href: '/assistant', icon: MessageCircle },
  { name: 'Budget', href: '/budget', icon: Wallet },
  { name: 'More', href: '/more', icon: MoreHorizontal },
];

const moreRoutes = [
  '/transactions',
  '/household',
  '/setup',
  '/onboarding',
  '/preferences',
  '/settings',
  '/help',
  '/invite',
  '/more',
];

export function BottomTabBar() {
  const location = useLocation();

  const isMoreActive = moreRoutes.some(r => location.pathname.startsWith(r));

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border pb-[env(safe-area-inset-bottom)]"
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="flex items-stretch h-16">
        {primaryTabs.map(tab => {
          const Icon = tab.icon;
          const isMore = tab.href === '/more';
          const isActive = isMore
            ? isMoreActive
            : location.pathname === tab.href ||
              location.pathname.startsWith(`${tab.href}/`);

          return (
            <Link
              key={tab.name}
              to={tab.href}
              data-tour={
                tab.name === 'Accounts'
                  ? 'nav-accounts-mobile'
                  : tab.name === 'More'
                    ? 'nav-more-mobile'
                    : undefined
              }
              className={cn(
                'relative flex min-w-0 flex-1 flex-col items-center justify-center gap-1 text-[10px] font-medium transition-colors min-[360px]:text-xs',
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              )}
              aria-current={isActive ? 'page' : undefined}
            >
              <span
                className={cn(
                  'flex h-7 w-12 items-center justify-center rounded-full',
                  isActive && 'bg-hero'
                )}
              >
                <Icon className="h-5 w-5" />
              </span>
              <span>{tab.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
